import { createSlice } from '@reduxjs/toolkit';

import { noop } from '@constants/general';
import { STATUS } from '@constants/status';

export const initialState = {
  login: {
    model: {
      email: '',
      token: '',
      password: '',
    },
  },
  resendOtp: {
    meta: {
      status: '',
    },
  },
};

export const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Login
    loginRequest: (state, { payload }) => {
      state.login.model.email = payload?.data?.email;
      state.login.model.password = payload?.data?.password;
      state.login.model.returnTo = payload?.returnTo;
    },
    setLoginToken: (state, { payload }) => {
      state.login.model.token = payload;
    },

    // Resend OTP
    resendOtpRequest: state => {
      state.resendOtp.meta.status = STATUS.LOADING;
    },
    resendOtpFinished: state => {
      state.resendOtp.meta.status = '';
    },

    // 2FA
    setupTwoFactorAuthRequest: noop,
    verifyOtpRequest: noop,

    logoutRequest: noop,
    reset: () => initialState,
  },
});

export const {
  loginRequest,
  setLoginToken,
  setupTwoFactorAuthRequest,
  resendOtpRequest,
  resendOtpFinished,
  logoutRequest,
  verifyOtpRequest,
  reset,
} = auth.actions;
export default auth.reducer;
